<div class="resource-item">
  <div class="header">{{#if url}}<a href="{{url}}" target="_blank">{{name}}</a>{{else}}{{name}}{{/if}}</div>
  <div class="description">{{body}}</div>
</div>